module.exports = __webpack_public_path__ + "static/mobile-1da0edb43917edf0af525d42bff81ce8.png";